import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'
import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class ConfigurationFieldsValueObject extends ValueObject {
  #id
  #name
  #label
  #placeholder
  #inputMode
  #leftIcon
  #maxLength
  #isRequired
  #type

  constructor({id, isRequired, name, label, placeholder, inputMode, leftIcon, maxLength, type}) {
    super()
    this.#id = id
    this.#isRequired = isRequired
    this.#name = name
    this.#label = label
    this.#placeholder = placeholder
    this.#inputMode = inputMode
    this.#leftIcon = leftIcon
    this.#maxLength = maxLength
    this.#type = type
  }

  static validate({id}) {
    const {VEHICLE_CONFIGURATOR_FIELDS_CONFIG} = ConfigContext.get('configurator')
    if (!VEHICLE_CONFIGURATOR_FIELDS_CONFIG[id]) {
      throw InvalidParamsSharedError.create(
        `[InvalidParamsSharedError] Configuration field with id "${id}" does not exist.`
      )
    }
  }

  static create({id, isRequired, name, label, placeholder, inputMode, leftIcon, maxLength, type}) {
    ConfigurationFieldsValueObject.validate({id})

    return new ConfigurationFieldsValueObject({
      id,
      isRequired,
      name,
      label,
      placeholder,
      inputMode,
      leftIcon,
      maxLength,
      type
    })
  }

  static createFromApi({id, isRequired, label, type}) {
    const {VEHICLE_CONFIGURATOR_FIELDS_CONFIG, FORM_INPUT_TYPES} = ConfigContext.get('configurator')

    const {
      name = '',
      label: defaultLabel,
      placeholder = '',
      inputMode: defaultInputMode = 'text',
      leftIcon = null,
      maxLength = null,
      isRequired: defaultIsRequired,
      type: defaultType = FORM_INPUT_TYPES.INPUT
    } = VEHICLE_CONFIGURATOR_FIELDS_CONFIG[id] || {}

    return ConfigurationFieldsValueObject.create({
      id,
      isRequired: isRequired || defaultIsRequired,
      name,
      label: label || defaultLabel,
      placeholder,
      inputMode: defaultInputMode,
      leftIcon,
      maxLength,
      type: type || defaultType
    })
  }

  hasLeftIcon() {
    return Boolean(this.#leftIcon)
  }

  hasMaxLength() {
    return Boolean(this.#maxLength)
  }

  get id() {
    return this.#id
  }

  get isRequired() {
    return this.#isRequired
  }

  get name() {
    return this.#name
  }

  get label() {
    return this.#label
  }

  get placeholder() {
    return this.#placeholder
  }

  get inputMode() {
    return this.#inputMode
  }

  get leftIcon() {
    return this.#leftIcon
  }

  get maxLength() {
    return this.#maxLength
  }

  get type() {
    return this.#type
  }

  get value() {
    return {
      id: this.#id,
      isRequired: this.#isRequired,
      name: this.#name,
      label: this.#label,
      placeholder: this.#placeholder,
      inputMode: this.#inputMode,
      leftIcon: this.#leftIcon,
      maxLength: this.#maxLength,
      type: this.#type
    }
  }

  toJSON() {
    return {
      id: this.#id,
      isRequired: this.#isRequired,
      name: this.#name,
      label: this.#label,
      placeholder: this.#placeholder,
      inputMode: this.#inputMode,
      leftIcon: this.#leftIcon,
      maxLength: this.#maxLength,
      type: this.#type
    }
  }
}
